export default __webpack_public_path__ + "static/media/29.3edec812.jpg";